import { clearHtmlTags } from '@/helpers/misc';

const beforeUploadForPhotoInformation = result => {
  const willUpload = [];

  result.files.forEach(f => {
    const { file } = f;

    if (result.addPhotoInformation) {
      file.source = f.source;
      file.reporter = f.author;
      file.content = clearHtmlTags(f.text);
    }

    willUpload.push(file);
  });

  return willUpload;
};

export default beforeUploadForPhotoInformation;
